import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout';
import CustomerQuoteSection from '../../components/shared/CustomerQuoteSection';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import CustomerGrid from './CustomerGrid';
import TryHoverTodaySection from '../../components/shared/TryHoverTodaySection';
import CustomerLogoGrid from './CustomerLogoGrid';
import CustomerHero from '../../images/hp-hero.webp';

const Customers = () => (
  <Layout
    title="HOVER's Happy Customers - Learn how our customers use HOVER in their workflow to be more efficient and close more business."
    description="Read about HOVER's customers. Learn how they are using HOVER to be more efficient, gain a competitive edge and close more business."
  >
    <HeroWithBackgroundImage
      imageUrl={CustomerHero}
      title="Customer Story - Rapid Roofing"
      description="A consultative sales approach means better customer experience and higher close rates."
      height="25vh"
      buttonText="Watch Now"
      ctaLink="https://hover.wistia.com/medias/l6e752c5qa"
    />
    <CustomerGrid />
    <CustomerLogoGrid />
    <CustomerQuoteSection
      image={
        <StaticImage
          style={{ borderRadius: '100%' }}
          src="../../images/customer-page-customer.png"
          alt="Icon Customer testimonial"
        />
      }
      authorDescription="Jamie Breneman , VP of Sales and Marketing, Chattanooga Exteriors"
      quote="
HOVER solved a credibility problem we didn’t know we had. Not only does it allow me to get estimates back to my customers sooner, but its professional presentation and accurate measurements sets our company apart."
    />
    <TryHoverTodaySection
      title="Start Using HOVER"
      description="If you’re impressed with these features, you have a lot more to be excited about."
      buttonText="Start Your Free Trial"
    />
  </Layout>
);

export default Customers;
